import { TypeSuggestion } from "../type";
import {
  FETCH_COUPANG_RECO_ERROR,
  FETCH_COUPANG_RECO_REQUEST,
  FETCH_COUPANG_RECO_SUCCESS,
  FETCH_FAVORITES_MAIN_ERROR,
  FETCH_FAVORITES_MAIN_REQUEST,
  FETCH_FAVORITES_MAIN_SUCCESS,
  FETCH_HISTORY_MAIN_ERROR,
  FETCH_HISTORY_MAIN_REQUEST,
  FETCH_HISTORY_MAIN_SUCCESS,
  FETCH_MY_INGREDIENTS_ERROR,
  FETCH_MY_INGREDIENTS_REQUEST,
  FETCH_MY_INGREDIENTS_SUCCESS,
  FETCH_RANDOM_RECIPE_ERROR,
  FETCH_RANDOM_RECIPE_REQUEST,
  FETCH_RANDOM_RECIPE_SUCCESS,
  FETCH_SUGGESTION_BY_TYPE_ERROR,
  FETCH_SUGGESTION_BY_TYPE_REQUEST,
  FETCH_SUGGESTION_BY_TYPE_SUCCESS,
  FETCH_USER_SUGGESTION_MAIN_ERROR,
  FETCH_USER_SUGGESTION_MAIN_REQUEST,
  FETCH_USER_SUGGESTION_MAIN_SUCCESS,
  FETCH_WEATHER_MAIN_ERROR,
  FETCH_WEATHER_MAIN_REQUEST,
  FETCH_WEATHER_MAIN_SUCCESS,
  IFetchFavoritesMainRequest,
  IFetchFavoritesMainResponse,
  IFetchHistoryMainRequest,
  IFetchHistoryMainResponse,
  IFetchMyIngredientsRequest,
  IFetchMyIngredientsResponse,
  IFetchRandomRecipeRequest,
  IFetchRandomRecipeResponse,
  IFetchSuggestionByTypeRequest,
  IFetchSuggestionByTypeResponse,
  IFetchWeatherMainRequest,
  IFetchWeatherMainResponse,
  IFetchCommunityMainResponse,
  FETCH_COMMUNITY_TREND_MAIN_REQUEST,
  FETCH_COMMUNITY_TREND_MAIN_SUCCESS,
  FETCH_COMMUNITY_TREND_MAIN_ERROR,
  IFetchCommunityTrendMainRequest,
  IFetchCommunityFollowMainRequest,
  IFetchCommunityVideoMainRequest,
  FETCH_COMMUNITY_FOLLOW_MAIN_REQUEST,
  FETCH_COMMUNITY_FOLLOW_MAIN_SUCCESS,
  FETCH_COMMUNITY_FOLLOW_MAIN_ERROR,
  FETCH_COMMUNITY_VIDEO_MAIN_REQUEST,
  FETCH_COMMUNITY_VIDEO_MAIN_SUCCESS,
  FETCH_COMMUNITY_VIDEO_MAIN_ERROR,
  RELOAD_USER_SUGGESTION_MAIN_REQUEST,
} from "./types";

export interface DataState {
  ingredients: {
    params: IFetchMyIngredientsRequest;
    data: IFetchMyIngredientsResponse[];
    loadingIngredients: boolean;
    error: Error | null;
  };
  random_recipes: {
    params: IFetchRandomRecipeRequest;
    data: IFetchRandomRecipeResponse[];
    loadingRandomRecipe: boolean;
    error: Error | null;
  };
  suggestion_by_type: {
    params: IFetchSuggestionByTypeRequest;
    TASTE: IFetchSuggestionByTypeResponse[];
    SITUATION: IFetchSuggestionByTypeResponse[];
    AGE: IFetchSuggestionByTypeResponse[];
    WEATHER: IFetchSuggestionByTypeResponse[];
    loading: boolean;
    loadingTaste: boolean;
    loadingSituation: boolean;
    loadingAge: boolean;
    loadingWeather: boolean;
    error: Error | null;
  };
  favorites_main: {
    params: IFetchFavoritesMainRequest;
    data: IFetchFavoritesMainResponse[];
    loadingFavoritesMain: boolean;
    error: Error | null;
  };
  weather_main: {
    params: IFetchWeatherMainRequest;
    data: IFetchWeatherMainResponse[];
    loadingWeatherMain: boolean;
    error: Error | null;
  };
  history_main: {
    params: IFetchHistoryMainRequest;
    data: IFetchHistoryMainResponse[];
    loadingHistoryMain: boolean;
    error: Error | null;
  };

  community_trend_main: {
    params: IFetchCommunityTrendMainRequest;
    data: IFetchCommunityMainResponse[];
    loadingCommunityTrendMain: boolean;
    error: Error | null;
  };

  community_follow_main: {
    params: IFetchCommunityFollowMainRequest;
    data: IFetchCommunityMainResponse[];
    loadingCommunityFollowMain: boolean;
    error: Error | null;
  };
  community_video_main: {
    params: IFetchCommunityVideoMainRequest;
    data: IFetchCommunityMainResponse[];
    loadingCommunityVideoMain: boolean;
    error: Error | null;
  };
  coupang_reco: {
    params: any;
    data: any;
    loading: boolean;
    error: Error | null;
  };
  user_suggestion_main: {
    params: IFetchWeatherMainRequest;
    data: IFetchWeatherMainResponse[];
    loadingUserSuggestionMain: boolean;
    error: Error | null;
  };
}
const initListIngredients = {
  params: {
    page: 1,
    page_size: 10,
  } as IFetchMyIngredientsRequest,
  data: [] as IFetchMyIngredientsResponse[],
  loadingIngredients: true,
  error: null,
};

const initListRandomRecipe = {
  params: {
    page: 1,
    page_size: 10,
  } as IFetchRandomRecipeRequest,
  data: [] as IFetchRandomRecipeResponse[],
  loadingRandomRecipe: true,
  error: null,
};

const initListFavoritesMain = {
  params: {
    page: 1,
    page_size: 10,
  } as IFetchFavoritesMainRequest,
  data: [] as IFetchFavoritesMainResponse[],
  loadingFavoritesMain: true,
  error: null,
};

const initListWeatherMain = {
  params: {
    page: 1,
    page_size: 10,
  } as IFetchWeatherMainRequest,
  data: [] as IFetchWeatherMainResponse[],
  loadingWeatherMain: true,
  error: null,
};

const initListHistoryMain = {
  params: {
    page: 1,
    page_size: 10,
  } as IFetchHistoryMainRequest,
  data: [] as IFetchHistoryMainResponse[],
  loadingHistoryMain: true,
  error: null,
};

const initListCommunityFollowMain = {
  params: {
    page: 1,
    page_size: 10,
    tab: "trend | follow | video",
  } as IFetchCommunityTrendMainRequest,
  data: [] as IFetchCommunityMainResponse[],
  loadingCommunityFollowMain: false,
  error: null,
};

const initListCommunityVideoMain = {
  params: {
    page: 1,
    page_size: 10,
    tab: "trend | follow | video",
  } as IFetchCommunityTrendMainRequest,
  data: [] as IFetchCommunityMainResponse[],
  loadingCommunityVideoMain: true,
  error: null,
};

const initListCommunityTrendMain = {
  params: {
    page: 1,
    page_size: 10,
    tab: "trend | follow | video",
  } as IFetchCommunityTrendMainRequest,
  data: [] as IFetchCommunityMainResponse[],
  loadingCommunityTrendMain: true,
  error: null,
};

const initListSuggestionByType = {
  params: {
    page: 1,
    page_size: 10,
    type: TypeSuggestion.TASTE,
  } as IFetchSuggestionByTypeRequest,
  TASTE: [] as IFetchSuggestionByTypeResponse[],
  SITUATION: [] as IFetchSuggestionByTypeResponse[],
  AGE: [] as IFetchSuggestionByTypeResponse[],
  WEATHER: [] as IFetchSuggestionByTypeResponse[],
  loading: true,
  loadingTaste: true,
  loadingSituation: true,
  loadingAge: true,
  loadingWeather: true,
  error: null,
};

const initListUserSuggestionMain = {
  params: {
    page: 1,
    page_size: 10,
  } as IFetchWeatherMainRequest,
  data: [] as IFetchWeatherMainResponse[],
  loadingUserSuggestionMain: true,
  error: null,
};

const initialState: DataState = {
  ingredients: initListIngredients,
  random_recipes: initListRandomRecipe,
  suggestion_by_type: initListSuggestionByType,
  favorites_main: initListFavoritesMain,
  weather_main: initListWeatherMain,
  history_main: initListHistoryMain,
  coupang_reco: {} as any,
  community_trend_main: initListCommunityTrendMain,
  community_follow_main: initListCommunityFollowMain,
  community_video_main: initListCommunityVideoMain,
  user_suggestion_main: initListUserSuggestionMain,
};

const mainReducer = (
  state: DataState = initialState,
  action: any
): DataState => {
  switch (action.type) {
    case FETCH_MY_INGREDIENTS_REQUEST:
      return {
        ...state,
        ingredients: {
          ...state.ingredients,
          params: action.payload,
          loadingIngredients: true,
          error: null,
        },
      };
    case FETCH_MY_INGREDIENTS_SUCCESS: {
      const newData = action.payload.map((item: any) => ({
        id: item.id,
        image: item.icon,
        text: item.translates[0].name,
        lang_id: item.translates[0].lang_id,
        created_at: item.created_at,
      }));
      return {
        ...state,
        ingredients: {
          ...state.ingredients,
          data: newData,
          loadingIngredients: false,
          error: null,
        },
      };
    }
    case FETCH_MY_INGREDIENTS_ERROR:
      return {
        ...state,
        ingredients: {
          ...state.ingredients,
          loadingIngredients: false,
          error: action.payload,
        },
      };
    //random recipe
    case FETCH_RANDOM_RECIPE_REQUEST:
      return {
        ...state,
        random_recipes: {
          ...state.random_recipes,
          params: action.payload,
          loadingRandomRecipe: true,
          error: null,
        },
      };
    case FETCH_RANDOM_RECIPE_SUCCESS: {
      const newData = action.payload.map((item: any) => ({
        id: item.id,
        thumbnail: item.thumbnail,
        video_id: item.video_id,
        name: item.name,
      }));
      return {
        ...state,
        random_recipes: {
          ...state.random_recipes,
          data: newData,
          loadingRandomRecipe: false,
          error: null,
        },
      };
    }
    case FETCH_RANDOM_RECIPE_ERROR:
      return {
        ...state,
        random_recipes: {
          ...state.random_recipes,
          loadingRandomRecipe: false,
          error: action.payload,
        },
      };
    //random recipe
    case FETCH_SUGGESTION_BY_TYPE_REQUEST:
      switch (action.payload.type) {
        case TypeSuggestion.TASTE:
          return {
            ...state,
            suggestion_by_type: {
              ...state.suggestion_by_type,
              params: action.payload,
              loadingTaste: true,
              error: null,
            },
          };
        case TypeSuggestion.SITUATION:
          return {
            ...state,
            suggestion_by_type: {
              ...state.suggestion_by_type,
              params: action.payload,
              loadingSituation: true,
              error: null,
            },
          };
        case TypeSuggestion.AGE:
          return {
            ...state,
            suggestion_by_type: {
              ...state.suggestion_by_type,
              params: action.payload,
              loadingAge: true,
              error: null,
            },
          };
        case TypeSuggestion.WEATHER:
          return {
            ...state,
            suggestion_by_type: {
              ...state.suggestion_by_type,
              params: action.payload,
              loadingWeather: true,
              error: null,
            },
          };
        default:
          return {
            ...state,
            suggestion_by_type: {
              ...state.suggestion_by_type,
              params: action.payload,
              loadingTaste: true,
              error: null,
            },
          };
      }
    case FETCH_SUGGESTION_BY_TYPE_SUCCESS: {
      switch (action.params) {
        case TypeSuggestion.TASTE:
          return {
            ...state,
            suggestion_by_type: {
              ...state.suggestion_by_type,
              TASTE: action.payload,
              loadingTaste: false,
              error: null,
            },
          };
        case TypeSuggestion.SITUATION:
          return {
            ...state,
            suggestion_by_type: {
              ...state.suggestion_by_type,
              SITUATION: action.payload,
              loadingSituation: false,
              error: null,
            },
          };
        case TypeSuggestion.AGE:
          return {
            ...state,
            suggestion_by_type: {
              ...state.suggestion_by_type,
              AGE: action.payload,
              loadingAge: false,
              error: null,
            },
          };
        case TypeSuggestion.WEATHER:
          return {
            ...state,
            suggestion_by_type: {
              ...state.suggestion_by_type,
              WEATHER: action.payload,
              loadingWeather: false,
              error: null,
            },
          };
        default:
          return {
            ...state,
            suggestion_by_type: {
              ...state.suggestion_by_type,
              TASTE: action.payload,
              loading: false,
              error: null,
            },
          };
      }
    }
    case FETCH_SUGGESTION_BY_TYPE_ERROR:
      return {
        ...state,
        suggestion_by_type: {
          ...state.suggestion_by_type,
          loading: false,
          loadingTaste: false,
          loadingSituation: false,
          loadingAge: false,
          loadingWeather: false,
          error: action.payload,
        },
      };

    case FETCH_FAVORITES_MAIN_REQUEST:
      return {
        ...state,
        favorites_main: {
          ...state.favorites_main,
          params: action.payload,
          loadingFavoritesMain: true,
          error: null,
        },
      };
    case FETCH_FAVORITES_MAIN_SUCCESS: {
      return {
        ...state,
        favorites_main: {
          ...state.favorites_main,
          data: action.payload,
          loadingFavoritesMain: false,
          error: null,
        },
      };
    }
    case FETCH_FAVORITES_MAIN_ERROR:
      return {
        ...state,
        favorites_main: {
          ...state.favorites_main,
          loadingFavoritesMain: false,
          error: action.payload,
        },
      };

    case "REMOVE_FAVORITES_MAIN":
      return {
        ...state,
        favorites_main: {
          ...state.favorites_main,
          data: state.favorites_main.data.filter(
            (item: any) => item.id !== action.payload.id
          ),
        },
      };
    case FETCH_WEATHER_MAIN_REQUEST:
      return {
        ...state,
        weather_main: {
          ...state.weather_main,
          params: action.payload,
          loadingWeatherMain: true,
          error: null,
        },
      };
    case FETCH_WEATHER_MAIN_SUCCESS: {
      return {
        ...state,
        weather_main: {
          ...state.weather_main,
          data: action.payload,
          loadingWeatherMain: false,
          error: null,
        },
      };
    }
    case FETCH_WEATHER_MAIN_ERROR:
      return {
        ...state,
        weather_main: {
          ...state.weather_main,
          loadingWeatherMain: false,
          error: action.payload,
        },
      };

    case FETCH_HISTORY_MAIN_REQUEST:
      return {
        ...state,
        history_main: {
          ...state.history_main,
          params: action.payload,
          loadingHistoryMain: true,
          error: null,
        },
      };
    case FETCH_HISTORY_MAIN_SUCCESS: {
      return {
        ...state,
        history_main: {
          ...state.history_main,
          data: action.payload,
          loadingHistoryMain: false,
          error: null,
        },
      };
    }
    case FETCH_HISTORY_MAIN_ERROR:
      return {
        ...state,
        history_main: {
          ...state.history_main,
          loadingHistoryMain: false,
          error: action.payload,
        },
      };

    case FETCH_COUPANG_RECO_REQUEST:
      return {
        ...state,
        coupang_reco: {
          ...state.coupang_reco,
          params: action.payload,
          loading: true,
          error: null,
        },
      };
    case FETCH_COUPANG_RECO_SUCCESS: {
      return {
        ...state,
        coupang_reco: {
          ...state.coupang_reco,
          data: action.payload,
          loading: false,
          error: null,
        },
      };
    }
    case FETCH_COUPANG_RECO_ERROR:
      return {
        ...state,
        coupang_reco: {
          ...state.coupang_reco,
          loading: false,
          error: action.payload,
        },
      };

    case FETCH_COMMUNITY_TREND_MAIN_REQUEST:
      return {
        ...state,
        community_trend_main: {
          ...state.community_trend_main,
          params: action.payload,
          loadingCommunityTrendMain: true,
          error: null,
        },
      };
    case FETCH_COMMUNITY_TREND_MAIN_SUCCESS: {
      return {
        ...state,
        community_trend_main: {
          ...state.community_trend_main,
          data: action.payload,
          loadingCommunityTrendMain: false,
          error: null,
        },
      };
    }
    case FETCH_COMMUNITY_TREND_MAIN_ERROR:
      return {
        ...state,
        community_trend_main: {
          ...state.community_trend_main,
          loadingCommunityTrendMain: false,
          error: action.payload,
        },
      };

    case FETCH_COMMUNITY_FOLLOW_MAIN_REQUEST:
      return {
        ...state,
        community_follow_main: {
          ...state.community_follow_main,
          params: action.payload,
          loadingCommunityFollowMain: true,
          error: null,
        },
      };
    case FETCH_COMMUNITY_FOLLOW_MAIN_SUCCESS: {
      return {
        ...state,
        community_follow_main: {
          ...state.community_follow_main,
          data: action.payload,
          loadingCommunityFollowMain: false,
          error: null,
        },
      };
    }
    case FETCH_COMMUNITY_FOLLOW_MAIN_ERROR:
      return {
        ...state,
        community_follow_main: {
          ...state.community_follow_main,
          loadingCommunityFollowMain: false,
          error: action.payload,
        },
      };

    case FETCH_COMMUNITY_VIDEO_MAIN_REQUEST:
      return {
        ...state,
        community_video_main: {
          ...state.community_video_main,
          params: action.payload,
          loadingCommunityVideoMain: true,
          error: null,
        },
      };
    case FETCH_COMMUNITY_VIDEO_MAIN_SUCCESS: {
      return {
        ...state,
        community_video_main: {
          ...state.community_video_main,
          data: action.payload,
          loadingCommunityVideoMain: false,
          error: null,
        },
      };
    }
    case FETCH_COMMUNITY_VIDEO_MAIN_ERROR:
      return {
        ...state,
        community_video_main: {
          ...state.community_video_main,
          loadingCommunityVideoMain: false,
          error: action.payload,
        },
      };
      case FETCH_USER_SUGGESTION_MAIN_REQUEST:
        return {
          ...state,
          user_suggestion_main: {
            ...state.user_suggestion_main,
            params: action.payload,
            loadingUserSuggestionMain: true,
            error: null,
            data: [],
          },
        };
      case FETCH_USER_SUGGESTION_MAIN_SUCCESS: {
        return {
          ...state,
          user_suggestion_main: {
            ...state.user_suggestion_main,
            data: action.payload,
            loadingUserSuggestionMain: false,
            error: null,
          },
        };
      }
      case FETCH_USER_SUGGESTION_MAIN_ERROR:
        return {
          ...state,
          user_suggestion_main: {
            ...state.user_suggestion_main,
            loadingUserSuggestionMain: false,
            error: action.payload,
          },
        };
      case RELOAD_USER_SUGGESTION_MAIN_REQUEST:
          return {
            ...state,
            user_suggestion_main: {
              ...state.user_suggestion_main,
              params: action.payload,
              loadingUserSuggestionMain: true,
              error: null,
            },
          };
    default:
      return state; // Add a default return statement
  }
};

export default mainReducer;
